import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'CLOSE_OPER',
  title: 'Comment clôturer une opération ?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Pour clôturer une opération :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur l’onglet « Opérations »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLOSE_OPER/FR_CLOSE_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur l’opération de votre choix'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLOSE_OPER/FR_CLOSE_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Cliquez en haut à droite sur les 3 points'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLOSE_OPER/FR_CLOSE_OPER_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Cliquez sur « Clôturer l’opération »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_CLOSE_OPER/FR_CLOSE_OPER_4.png`
  }]
};
